<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ livecasino_title }}
      td.text-center {{ livecasino_upline_pt }}%
      td.text-center(v-show="isSearch") {{ livecasino_account_pt }}%
      td.text-center(v-show="isSearch") {{ livecasino_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ livecasino_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false
  },
  data() {
    return {
      livecasino_upline_min: 0,
      livecasino_upline_max: 0,
      livecasino_upline_pt: 0,
      livecasino_account_pt: 0,
      livecasino_upline_remaining: 0,
      livecasino_account_min: 0
    }
  },
  computed: {
    livecasino_title: function () {
      return this.$t("ui.live_casino") + " (" + this.livecasino_upline_min + "%-" + this.livecasino_upline_max + "%)"
    }
  }
}

</script>